import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { CorporatesState } from "../actions/corporates"

interface IPayloadOpenDrawer {
	isEditMode: boolean
	tabIndex?: number
	corporate?: CorporatesState | undefined
}

export interface ICorporateEditState {
	isDrawerOpen: boolean
	isEditMode: boolean
	tabIndex: number
	currentCorporate: CorporatesState | undefined
}

const initialState: ICorporateEditState = {
	isDrawerOpen: false,
	isEditMode: false,
	tabIndex: 0,
	currentCorporate: undefined,
}

const corporateEditSlice = createSlice({
	name: "corporateEdit",
	initialState,
	reducers: {
		openDrawer: (
			state: ICorporateEditState,
			action: PayloadAction<IPayloadOpenDrawer>
		) => {
			state.isDrawerOpen = true
			state.isEditMode = action.payload.isEditMode || false
			state.currentCorporate = action.payload.corporate || undefined
			state.tabIndex = action.payload.tabIndex || 0
		},
		closeDrawer: (state) => {
			state.isDrawerOpen = false
			state.isEditMode = false
			state.currentCorporate = undefined
		},
	},
})

export const { openDrawer, closeDrawer } = corporateEditSlice.actions
export default corporateEditSlice.reducer
